import { Outlet } from 'react-router-dom';

import { CssBaseline, GlobalStyles, styled } from '@sbv-clients/ui-shared';

const Root = styled('div')`
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface AuthLayoutProps {}

const PublicRouteLayout = (props: AuthLayoutProps) => {
  return (
    <Root>
      <CssBaseline />
      <GlobalStyles />
      <Outlet />
    </Root>
  );
};

export default PublicRouteLayout;
